import * as types from './types';

const initialState = {
  data: null,
  timeRange: {
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    endDate: new Date()
  },
  filters: {
    properties: [],
    tags: [],
    staff: []
  },
  isLoading: false
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ANALYTICS_DATA:
      return {
        ...state,
        data: action.payload
      };
      
    case types.SET_ANALYTICS_TIME_RANGE:
      return {
        ...state,
        timeRange: action.payload
      };
      
    case types.SET_ANALYTICS_FILTERS:
      return {
        ...state,
        filters: action.payload
      };
      
    case types.SET_ANALYTICS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
      
    default:
      return state;
  }
};

export default analyticsReducer; 